import { SettingsPageLayout } from "../components/SettingsPageLayout";
import { RealEstateAssetsForm } from "./RealEstateAssetsForm";
import { useNavigate } from "react-router-dom";

/**
 * Real Estate & Other Assets page - Mobile implementation
 * Full-screen wrapper with swipe navigation (< 768px)
 * Delegates form rendering to the shared RealEstateAssetsForm component.
 */
function RealEstateAssetsMobile() {
  const navigate = useNavigate();

  return (
    <SettingsPageLayout
      title="Real Estate & Other Assets"
      category="realEstateAssets"
      loading={false}
      onBack={() => navigate("/settings")}
    >
      <RealEstateAssetsForm />
    </SettingsPageLayout>
  );
}

export default RealEstateAssetsMobile;
